import React, { useEffect, useState, useContext } from 'react';
import TopNav from 'components/TopNav';
import BottomNav from 'components/BottomNav';
import { Dialog, DialogContent, FormControlLabel, Switch } from '@material-ui/core';
import styles from './style.module.scss';
import { useQueryClient } from 'react-query';
import * as profileApi from 'api/profile';
import ErrorMessage from '../../../common/error';
import { fullwidthToHalfwidthNumber } from 'utils/utils';
import { AuthContext } from '../../../context/AuthContext';

function ChangeLoginType() {
  const authContext = useContext(AuthContext);
  const queryClient = useQueryClient();
  const userProfile = authContext.userProfile

  const [loginType, setLoginType] = useState(0);
  const [password, setPassword] = useState('');
  const [messageErr, setMessageErr] = useState();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        setVisible(false);
      }, 3000);
    }
  }, [visible]);

  useEffect(() => {
    setLoginType(userProfile.needOtp);
  }, [userProfile]);

  const ChangeLoginType = () => {
    setLoginType((e) => !e);
  };
  const handleSubmit = async () => {
    if (loginType && (password === '' || password.toString().length !== 6) && userProfile.needOtp) {
      setAlertMessage(ErrorMessage.validate_password);
    } else {
      if (window.confirm('ログイン方法を変更してよろしいですか？')) {
        let data = {
          needOtp: Number(loginType),
          password: password === '' ? userProfile.password.toString() : password.toString(),
        };
        try {
          await profileApi.updateLoginType(data);
          setPassword('');
          setAlertMessage('ログイン方法とパスワードを更新しました');
          queryClient.invalidateQueries('userProfile');
        } catch (e) {
          setAlertMessage(e.response?.data?.message);
        }
      }
    }
  };

  const setAlertMessage = (message) => {
    setMessageErr(message);
    setVisible(true);
  };

  const handleConvertFullWidth = async(value) => {
   let convertValue = await fullwidthToHalfwidthNumber(value)
    if(isNaN(convertValue)){
      setPassword('')
    }else{
      setPassword(+convertValue)
    }
  }

  return (
    <div style={{ overflow: 'auto', height: '100vh' }}>
      <div style={{ maxWidth: 560, margin: 'auto' }}>
        <TopNav name={`パスワードとログイン方法の登録変更`} hasBackIcon={true} />
        <div className={`${styles.changePhone} align-top`}>
          <form action="/" method="post">
            <div className={styles.back_white_wrap}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className="align-center mb-heading">
                  <span className="stick-icon">&nbsp;</span>
                  <span className="title font-4">パスワードとログイン方法の登録変更</span>
                </div>
              </div>
              <div>
                <span className="title font-3">
                  ログイン方法をSMS送信方式から、お好きなパスワードでログインできるように設定できます。
                  <br />
                  ログインが簡単なパスワード方式の設定をお勧めしております。
                </span>
              </div>
              <div className={styles.divInputOne}>
                <div className={styles.infoRow}>
                  <span className="font-2">現在のパスワード</span>
                  <span className="font-2">{userProfile.password ? userProfile.password : ''}</span>
                </div>

                <div className={`d-flex ${styles.infoRow2}`} style={{ justifyContent: 'space-between' }}>
                  <span className="font-2">ログイン方法</span>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      height: 35,
                      width: 'calc(100% - 100px)',
                    }}
                    className={`${styles.dLine}`}
                  >
                  <span className="font-2">
                    <div className={styles.switch}>
                      SMS方式
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={!!loginType}
                            onChange={ChangeLoginType}
                            classes={{
                              checked: styles.checked,
                              switchBase: styles.switchBase,
                              bar: styles.bar,
                            }}
                          />
                        }
                      />
                      パスワード方式
                    </div>
                  </span>
                  </div>
                </div>

                <div className={styles.divInputOne}>
                  <label className="font-2">新しいパスワード（数字6桁）</label>
                  <input
                    disabled={!loginType}
                    id="name"
                    name="phone"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onBlur={(e) => handleConvertFullWidth(e.target.value)}
                    placeholder="パスワード"
                  />
                </div>
              </div>


              <br />
              <div onClick={handleSubmit}>
                <center>
                  <div id="sign-in-button"></div>
                </center>
                <div className={styles.divSubmit}>
                  <div className="btn-main btn-submit">次へ</div>
                </div>
              </div>
            </div>
          </form>

          <Dialog
            open={visible}
            onClose={() => setVisible(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            style={{ opacity: 0.6 }}
          >
            <DialogContent style={{ backgroundColor: 'var(--black)' }} onClick={() => setVisible(false)}>
              <span style={{ color: 'var(--white)', fontWeight: 'bold' }}>{messageErr}</span>
            </DialogContent>
          </Dialog>
        </div>
        <BottomNav />
      </div>
    </div>
  );
}

export default ChangeLoginType;
